import { render, staticRenderFns } from "./FeesDetails.vue?vue&type=template&id=688eb84e&scoped=true&"
import script from "./FeesDetails.vue?vue&type=script&lang=ts&"
export * from "./FeesDetails.vue?vue&type=script&lang=ts&"
import style0 from "./FeesDetails.vue?vue&type=style&index=0&id=688eb84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688eb84e",
  null
  
)

export default component.exports